"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var react_1 = require("react");
var lodash_throttle_1 = __importDefault(require("lodash.throttle"));
var useWillUnmount_1 = __importDefault(require("../useWillUnmount"));
var useMemoizedFn_1 = __importDefault(require("../useMemoizedFn"));
var defaultOptions = {
  leading: false,
  trailing: true
};
var useThrottled = function useThrottled(fn, wait, options) {
  if (wait === void 0) {
    wait = 100;
  }
  if (options === void 0) {
    options = defaultOptions;
  }
  var throttled = (0, react_1.useRef)((0, lodash_throttle_1["default"])(fn, wait, options));
  (0, react_1.useEffect)(function () {
    throttled.current = (0, lodash_throttle_1["default"])(fn, wait, options);
  }, [fn, wait, options]);
  (0, useWillUnmount_1["default"])(function () {
    var _a;
    (_a = throttled.current) === null || _a === void 0 ? void 0 : _a.cancel();
  });
  return (0, useMemoizedFn_1["default"])(throttled.current);
};
exports["default"] = useThrottled;